export class PortalMessageThreadType {
  static mainClaimThread = 1;
  static workshopCommunicationClaimThread = 2;
  static customClaimThread = 3;

}
